import FavoriteIcon from "@/assets/icons/favorite.svg";
import StatusPage, { StatusPageProps } from "@/containers/StatusPages";

const EmptyFavorites: React.FunctionComponent<Partial<StatusPageProps>> = (
  props
) => {
  return (
    <StatusPage
      data-testid="empty-root"
      icon={FavoriteIcon}
      title={L.FAVORITES_EMPTY_TITLE}
      subtitle={L.FAVORITES_EMPTY_SUBTITLE}
      {...props}
    />
  );
};

export default EmptyFavorites;
